import { AssetReference } from '@opallabs/cassini'
import { ContentAvatar } from '../../../../../ContentAvatar'
import * as styles from './styles'

interface RedditPromotedHeaderProps {
  accountImage: AssetReference | null
  accountUsername: string
}

export const RedditPromotedHeader: React.FC<RedditPromotedHeaderProps> = ({
  accountImage,
  accountUsername,
}) => {
  const displayUsername = accountUsername
    ? `u/${accountUsername}`
    : 'u/username'

  return (
    <div css={styles.headerWrapper}>
      <ContentAvatar assetReference={accountImage} size={32} />
      <div css={styles.headerInfo}>
        <div css={styles.usernameRow}>
          <span css={styles.username}>{displayUsername}</span>
          <span css={styles.dotSeparator}>•</span>
          <span css={styles.promotedBadge}>Promoted</span>
        </div>
      </div>
    </div>
  )
}
